import { Chart } from 'primereact/chart'
import NumberFormat from 'react-number-format'
import { useSelector } from 'react-redux'

export const ReportByAreas = ({ data }) => {

    // const { simbolo, separacion_miles, separacion_decimales } = useSelector(state => state.general.detail)

    const {
        // local_moneda: moneda,
        local_simbolo: simbolo,
        local_separacion_miles: separacion_miles,
        local_separacion_decimales: separacion_decimales
    } = useSelector(state => state.general.info)

    return (
        <div className="mt-4 bg-white p-3 rounded-2xl">
            <h5 className="text-[15px]">Por unidad de negocio</h5>

            <div className='table-responsive'>
                <table className="table p-table-global mt-2">
                    <thead className='p-thead-global'>
                        <tr className="text-center p-tr-titles-global">
                            <th>Área</th>
                            <th>Generadas</th>
                            <th>Aprobadas</th>
                            <th>Total</th>
                            <th>Tasa conversión</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data?.map(it => {
                            const hasData = it.generadas + it.aprobadas

                            if (hasData) {
                                return (
                                    <tr className='p-tr-body-global' key={it.id}>
                                        <td className="text-start">{it.area}</td>
                                        <td className="text-center">{it.generadas}</td>
                                        <td className="text-center">{it.aprobadas}</td>
                                        <td className="text-end">
                                            <NumberFormat
                                                value={parseFloat(it?.monto_total || 0)}
                                                displayType={'text'}
                                                thousandSeparator={separacion_miles}
                                                decimalSeparator={separacion_decimales}
                                                prefix={`${simbolo} `}
                                                decimalScale={2}
                                                fixedDecimalScale={2}
                                            />
                                        </td>
                                        <td className="text-center">{it.tasa_conversion}%</td>
                                    </tr>
                                )
                            }

                            return ''

                        })}
                    </tbody>
                </table>
            </div>

            <div className="col d-flex justify-content-center mt-4">
                <BarChart data={data} />
            </div>
        </div>

    )
}

const BarChart = ({ data }) => {

    let names = []
    let generados = []
    let aprobados = []
    // let conversion = []

    for (let x = 0; x < data.length; x++) {
        const hasData = data[x].generadas + data[x].aprobadas
        if (hasData) {
            names = [...names, data[x].area]
            generados = [...generados, data[x].generadas]
            aprobados = [...aprobados, data[x].aprobadas]
            // conversion = [...conversion, data[x].tasa_conversion]
        }
    }

    const chartData = {
        labels: names,
        datasets: [
            // {
            //     type: 'line',
            //     label: 'Conversión',
            //     borderColor: '#5CBF66',
            //     borderWidth: 2,
            //     fill: false,
            //     tension: 0.4,
            //     data: conversion
            // },
            {
                type: 'bar',
                label: 'Generadas',
                backgroundColor: '#b6cfff',
                data: generados,
                borderColor: 'white',
                borderWidth: 2
            },
            {
                type: 'bar',
                label: 'Aprobadas',
                backgroundColor: 'orange',
                data: aprobados,
                borderColor: 'white',
                borderWidth: 2
            }
        ]
    };

    const chartOptions = {
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    }

    return (
        <Chart type="line" data={chartData} options={chartOptions} style={{ position: 'relative', width: '100%' }} />
    )

}
